import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { OAuthConsentPage } from "@/features/wonda/components/OAuthConsentPage";

const oauthConsentSearchSchema = z.object({
  token: z.string(),
});

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/oauth/consent",
)({
  validateSearch: zodValidator(oauthConsentSearchSchema),
  component: OAuthConsentRoute,
});

function OAuthConsentRoute() {
  const { token } = Route.useSearch();
  return <OAuthConsentPage token={token} />;
}
